import axios from "axios";
import { configJson, firebaseDatabase } from "../firebaseUtils";
import { hashTriibo1, validateRegistrationDate } from "../../utils/helpers";

export function getChannelToken_v1(uId) {
  const triiboHeader = {
    apiToken: configJson.apiToken,
    channelGroup: configJson.channelGroup,
    channelName: configJson.channelName,
    uId: uId,
    channelId: configJson.channelId,
    sessionId: "001",
    transactionId: "002",
  };

  return new Promise((resolve, reject) => {
    //capturando dados do Storage
    const channelObj = JSON.parse(localStorage.getItem("ivoclarChannelToken"));

    const valideDate = validateRegistrationDate(
      channelObj === null ? null : channelObj.registrationDate
    );
    const channelUId = channelObj === null ? null : channelObj.uId;

    //token não existe no storage
    if (
      channelObj === null ||
      channelObj.id === null ||
      channelObj.id === "" ||
      channelObj.id === undefined ||
      !valideDate ||
      channelUId === undefined ||
      channelUId === null ||
      channelUId !== uId
    ) {
      const passPhrase = firebaseDatabase
        .ref("triibo-auth-api-channel")
        .push().key;
      const challenge = hashTriibo1(
        configJson.apiToken,
        passPhrase,
        configJson.channeltoken
      );

      axios
        .post(configJson.API_HOST_V1 + "getChannelToken_v1", {
          triiboHeader: {
            apiToken: configJson.apiToken,
            channelGroup: configJson.channelGroup,
            channelName: configJson.channelName,
            uId: uId,
            passPhrase: passPhrase,
            challenge: challenge,
            channelId: configJson.channelId,
          },
        })
        .then((result) => {
          //console.log('RESULTADO GET CHANNEL TOKEN', result);
          localStorage.setItem(
            "ivoclarChannelToken",
            '{ "id":"' +
              challenge +
              '", "registrationDate":' +
              Date.now() +
              ', "uId":"' +
              uId +
              '" }'
          );

          triiboHeader.channelTokenId = challenge;

          resolve(triiboHeader);
        })
        .catch((error) => {
          //console.log('ERRO GET CHANNEL TOKEN', error.response);
          reject(error);
        });
    }
    //token existe no storage
    else {
      triiboHeader.channelTokenId = channelObj.id;
      resolve(triiboHeader);
    }
  });
}
